import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { RootState } from "Realty/store";
import {
    selectSubscriptionExpiresAt,
    selectSubscriptionLevel,
} from "../../../../../../../store/selectors";
import { connect } from "react-redux";
import { SUBSCRIPTION_PLANS } from "../../../../../../../constants/common";
import { format } from "date-fns";
import { ru } from "date-fns/locale/ru";

type PaidPeriodProps = {
    paidTill?: string;                // старый формат, если ещё где-то живёт
    handleClose: () => void;
    subscriptionLevel: string;       // "default" | "personal" и т.п.
    expiresAt?: string | null;       // новый формат из бэка
};

export const _PaidPeriod = ({
                                paidTill,
                                handleClose,
                                subscriptionLevel,
                                expiresAt,
                            }: PaidPeriodProps) => {
    const plan =
        SUBSCRIPTION_PLANS[subscriptionLevel] || SUBSCRIPTION_PLANS.default;

    // ==== статус по сетке тарифов ====
    const hasRestrictions = (plan.restrictions?.length ?? 0) > 0;
    const isActive = !hasRestrictions;

    const statusLabel = isActive ? "АКТИВНА" : "ОГРАНИЧЕНА";

    // ==== человекочитаемая дата (если есть) ====
    const readableExpires =
        expiresAt &&
        format(new Date(expiresAt), "d MMMM yyyy 'в' HH:mm", { locale: ru });

    const finalDate = readableExpires || paidTill;

    return (
        <div className="flex flex-col gap-3 text-sm text-slate-900">
            <div className="flex items-start justify-between gap-3">
                <div className="flex flex-col">
          <span className="text-[15px] font-semibold">
            {plan.displayName}
          </span>
                    <span className="mt-1 text-xs text-[#818c99]">
            {plan.description}
          </span>
                </div>

                <span className="shrink-0 rounded-full bg-[#f5e0ee] px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-[#c06198]">
          {statusLabel}
        </span>
            </div>

            {finalDate && (
                <p className="text-xs font-medium text-[#0f766e]">
                    до {finalDate}
                </p>
            )}

            <div className="mt-1">
                <Link
                    className="inline-flex w-full items-center justify-center rounded-2xl bg-[#c06198] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#a44f81]"
                    to="/payment"
                    onClick={handleClose}
                >
                    {isActive ? "Сменить тариф" : "Оформить подписку"}
                </Link>
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    subscriptionLevel: selectSubscriptionLevel(state),
    expiresAt: selectSubscriptionExpiresAt(state),
});

export const PaidPeriod = connect(mapStateToProps, null)(_PaidPeriod);
